(function () {
    'use strict';

    angular
        .module('app')
        .factory('urlSearchService', urlSearchService);

    urlSearchService.$inject = ['savedSearchService', 'favoritesService', 'gridDataService', 'searchService', '$timeout', '$state', '$localStorage', 'columnFactory', '$filter'];

    function urlSearchService(savedSearchService, favoritesService, gridDataService, searchService, $timeout, $state, $localStorage, columnFactory, $filter) {
        var service = {
            execute: execute
        };

        return service;

        function execute(obj) {
            //reset actives
            savedSearchService.resetActive();
            favoritesService.resetActive();


            $timeout(function () {
                //get all the columns first in order to do field lookups
                console.log("about to get columns");
                columnFactory.getAllColumns().then(function (data) {
                    console.log("got columns");
                    var criteria = [];
                    var failed = false;
                    var columns = data.data ? data.data : data;
                    //set the mode of search, 2 = fieldName, 3 = schemaID, any other = displayName
                    var mode = parseInt(obj["mode"]);

                    //iterate each property to look for fields
                    angular.forEach(obj, function (value, prop) {
                        var schemaId = "";
                        //ignore mode and type
                        if (prop != "mode" && prop != "type") {
                            //use the appropriate lookup according to the mode provided
                            switch (mode) {
                                case 2:
                                    //look up by fieldName
                                    var field = $filter('filter')(columns, { fieldName: prop })[0];
                                    if (field) {
                                        schemaId = field.schemaID;
                                    }
                                    break;
                                case 3:
                                    //look up by schemaID
                                    var field = $filter('filter')(columns, { schemaID: prop })[0];
                                    if (field) {
                                        schemaId = field.schemaID;
                                    }
                                default:
                                    //look up by displayName
                                    var field = $filter('filter')(columns, { displayName: prop })[0];
                                    if (field) {
                                        schemaId = field.schemaID;
                                    }
                                    break;
                            }

                            //if the field is missing set the flag to failed.
                            if (!schemaId) {
                                failed = true;
                            }

                            //add the criteria using the schemaId and value provided
                            criteria.push({
                                schemaID: schemaId,
                                valueStr: value,
                                startDate: "",
                                endDate: "",
                                searchOp: 0, // Starts with
                                bSystem: true // System searches are not saved as last search.
                            });

                        }
                    });

                    //if any field lookup failed, alert and return.
                    if (failed) {
                        alert("Invalid field(s) provided");
                        return;
                    }

                    $localStorage.userSettings["searchCriteria"] = criteria;
                    searchService.searchCriteria = criteria;

                    gridDataService.genericDataService = searchService;
                    //must identify the service in order to inject the correct one.
                    gridDataService.serviceIdentifier = "searchService";
                    //reset, since it's a new search
                    gridDataService.totalRecords = 0;
                    gridDataService.processing = true;

                    //timeout so the overlay can be displayed and not the previous records.
                    $state.go('layout.results.grid').then(function () {
                        $timeout(function () {
                            var getType = {};
                            if (getType.toString.call(gridDataService.reloadGrid) === '[object Function]') {
                                gridDataService.reloadGrid();
                            }
                        });
                    });
                });  

            }, 2000)
     
        }
    }
})();